/**
 * SubscriptionCanceledPage - Shown when customer cancels Stripe checkout
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const SubscriptionCanceledPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 px-4">
      <div className="max-w-md w-full bg-gray-800/50 border border-gray-700 rounded-2xl p-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-700 mb-4">
          <XCircle className="text-gray-400" size={32} />
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">Checkout Canceled</h1>
        <p className="text-gray-400 mb-6">
          Your payment was not completed. No charges have been made.
        </p>
        <div className="space-y-3">
          <a
            href="https://valutten.com/pricing"
            className="block w-full py-3 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors font-medium"
          >
            Return to Pricing
          </a>
          <button
            onClick={() => navigate('/login')}
            className="block w-full py-3 bg-gray-700 text-white rounded-lg hover:bg-gray-600 transition-colors font-medium"
          >
            Already have an account? Log in
          </button>
        </div>
        <p className="text-sm text-gray-500 mt-6">
          Need help? Contact us at support@valutten.com
        </p>
      </div>
    </div>
  );
};

export default SubscriptionCanceledPage;
